<template>
  <Modal
    v-model:show="active"
    :class="[{ loading: sending }, { completeClass: complete }]"
    class="modal-password profile__modal-change-password"
    @close="close"
  >
    <template v-slot:header>
      <h5 class="modal-title">
        {{ $t('profile.changePassword.title') }}
      </h5>
    </template>

    <Complete
      v-if="complete"
      :message="$t('dialogues.PassChangeSuccess')"
    />

    <div
      v-else
      @keyup.enter="save"
    >
      <UiInput
        v-model="model.old_password"
        v-model:error="error.old_password"
        class="mb-12"
        :label="$t('profile.changePassword.oldPassword')"
        type="password"
        placeholder="********"
        required
        error-clear-on-change
      />
      <UiInput
        v-model="model.new_password"
        v-model:error="error.new_password"
        class="mb-12"
        :label="$t('profile.changePassword.newPassword')"
        type="password"
        placeholder="********"
        required
        error-clear-on-change
      />
      <UiInput
        v-model="model.repeat_password"
        v-model:error="error.repeat_password"
        :label="$t('profile.changePassword.repeatPassword')"
        type="password"
        placeholder="********"
        required
        error-clear-on-change
      />
    </div>

    <template v-slot:footer>
      <div
        v-if="!complete"
        class="!tw-flex !tw-justify-end modal__footer-btn"
      >
        <button
          class="btn btn-outline-primary btn-sm modal__btn-cancel mt-8"
          @click="close"
        >
          {{ $t('profile.buttons.cancel') }}
        </button>
        <button
          :disabled="!valid || sending"
          class="btn btn-primary btn-sm modal__btn-save ml-16 mt-8"
          @click="save"
        >
          <i
            v-if="sending"
            :class="{'transparent-top':sending}"
            class="fas fa-spinner spinner-hide !tw-relative"
          />
          <span :class="{'transparent-t':sending}">{{ $t('profile.buttons.save') }}</span>
        </button>
      </div>
      <div
        v-if="complete"
        class="modal__checkOk"
      >
        <button
          class="btn btn-primary btn-md modal__btn-cancel"
          @click="close"
        >
          {{ $t('profile.disableSuccess.ok') }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, sameAs } from '@vuelidate/validators';
import { Modal } from '@/components';
import Complete from '@/components/ModalForm/Complete.vue';

export default {
  components: {
    Modal,
    Complete,
  },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      active: false,
      validation: false,
      model: {
        old_password: '',
        new_password: '',
        repeat_password: '',
      },
      sending: false,
      complete: false,
      error: {},
      password_show: false,
    };
  },
  validations: {
    model: {
      new_password: {
        required,
        minLength: minLength(8),
      },
      repeat_password: {
        required,
        minLength: minLength(8),
        sameAs: sameAs('new_password'),
      },
    },
  },
  computed: {
    valid() {
      const new_pwd = this.v$.model.new_password;
      const rep_pwd = this.v$.model.repeat_password;
      return new_pwd.minLength && new_pwd.required && rep_pwd.sameAs;
    },
  },
  watch: {
    active(condition) {
      if (!condition) {
        this.sending = false;
        this.error = {};
        this.complete = false;
        this.disabled = false;
        this.$event.$emit('forms/reset');
      }
    },
  },
  methods: {
    reset() {
      this.model = {
        old_password: '',
        new_password: '',
        repeat_password: '',
      };
    },
    open(payload) {
      this.reset();
      this.payload = payload;
      this.active = true;
      document.addEventListener('keydown', this.keydownListener, true);
    },
    close() {
      this.active = false;
      this.sending = false;
      this.error = {};
      this.complete = false;
      this.reset();
      document.removeEventListener('keydown', this.keydownListener, true);
    },
    keydownListener(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        if (this.valid && !this.sending) this.save();
      }
    },
    save() {
      if(this.model.repeat_password !== this.model.new_password) {
        this.error.repeat_password = this.$t('forms.passwordsNotMatch');
        return;
      }

      const fields = {
        old_password: this.model.old_password,
        new_password: this.model.repeat_password,
      };
      this.sending = true;
      this.disabled = true;
      this.$store
        .dispatch('saveProfilePassword', fields)
        .then(() => {
          this.complete = true;
          this.sending = false;
        })
        .catch((error) => {
          this.error = error.response.data.errors;
          this.sending = false;
          this.complete = false;
        });
    },
  },
};
</script>

<style lang="scss">
// дубликатов нет
@import 'src/assets/theme/default/profile/changepassword';

.completeClass {
  h1 {
    margin: 30px auto;
    width: 60px;
  }
  .modal__footer-btn {
    display: none;
  }
  .modal__checkOk {
    display: block;
    .btn {
      width: 100%;
    }
  }
}

.modal__footer-btn {
  .modal__btn-cancel {
    min-width: 120px !important;
  }
  .modal__btn-confirm {
    position: relative;
    .sendingPassword {
      opacity: 0;
    }
  }
}
.profile__modal-change-password {
  .modal.loading {
    .fa-spinner {
      display: inline;
    }
    .confirm {
      font-size: 12px;
    }
  }
  .fa-spinner:before {
    position: absolute;
    font-size: 25px;
    top: -14px;
    left: 43%;
    animation-name: spin;
    animation-duration: 1500ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}

.modal__body.sendingPassword {
  opacity: 0.7;
}
</style>
